import req from "../http";

const country = {
  // 取得 縣市
  getCountry(params) {
    return req("get", "/BasicInformation/Nationality", params);
  }
};

export default country;